import React from 'react'
import { observer } from 'mobx-react'

import { IProps as ITableCellEditorParams } from './TableCellEditor'

import styles from './stringInput.scss'

interface IProps extends ITableCellEditorParams {
  initialValue: number | null
}

interface IState {
  value: number | null
}

class NumberInput extends React.PureComponent<IProps, IState> {
  private input: React.RefObject<HTMLInputElement> = React.createRef()

  constructor(props: IProps) {
    super(props)

    const { initialValue } = props
    const value =
      initialValue === undefined || initialValue === null
        ? null
        : parseFloat(`${initialValue}`) // Need the explicit `parseFloat` because initialValue is not guaranteed to be a number

    this.state = {
      value,
    }
  }

  // Called by ag-grid to get the final value when editing is finished
  getValue = () => this.state.value

  focus = () => {
    this.input.current?.focus()
  }

  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value

    if (value === '') {
      // When a number field is emptied, we just set it to null
      this.setState({ value: null })
      return
    }

    const valueAsNumber = parseFloat(value)

    this.setState({ value: valueAsNumber })
  }

  render() {
    const { value } = this.state

    return (
      <input
        data-cy="input--number"
        ref={this.input}
        className={styles.input}
        type="number"
        value={value === null || value === undefined ? '' : String(value)}
        placeholder="null"
        onChange={this.handleChange}
      />
    )
  }
}

export default observer(NumberInput)
